.atm_vh_nkobfv{vertical-align:middle;}
.atm_w8mpmz_glywfm:focus{outline:none;}
.atm_1bot3k6_19vzvmd svg{transition:fill 200ms ease-in-out;}
.atm_1jlwsa_1aemfod:hover svg,.atm_1jlwsa_1aemfod:focus svg{fill:#146EF5;}
